import React, { useState } from "react";
import SideBarStyle from "../../../assets/stylesheets/farm-detail/sections/SideBar.module.css";
import Logger from "../../../utils/logger";

// const log = Logger.create('SaveShareButtons');

export default function SaveFarmCard() {
  const [saved, setSaved] = useState(false);

  return (
    <div className={SideBarStyle["save-card"]}>
      {/* <p className={SideBarStyle["save-title"]}>View Products</p> */}
        <div className={SideBarStyle["verified-badge"]}>
          <span className={SideBarStyle["verified-icon"]}>🧑‍🌾</span>
          <span className={SideBarStyle["verified-text"]}>
            Verified by FarmCiti – Loved by visitors!
          </span>
        </div>
      {/* <button
        className={`
          ${SideBarStyle["save-btn"]} 
          ${saved ? SideBarStyle["is-saved"] : ""}
        `}
        onClick={() => setSaved((s) => !s)}
        aria-pressed={saved}
      >
        <SaveIcon
          className={styles["save-icon"]}
          aria-label={saved ? "Saved" : "Save"}
        />
        <span className={SideBarStyle["save-btn-title"]}>
          {saved ? "Saved" : "Save"}
          Visit Farm Store
        </span>
      </button> */}
    </div>
  );
}
